import React from 'react';
import styled from 'styled-components';
import useVimeo from '../../../acropolisCommon/hooks/useVimeo';

const vimeoPageToEmbed = (url) => {
    if (!url) return '';
    const m = String(url).match(/vimeo\.com\/(?:video\/)?(\d+)(?:\/([a-f0-9]+))?/i);
    if (!m) return url;
    return m[2]
        ? `https://player.vimeo.com/video/${m[1]}?h=${m[2]}`
        : `https://player.vimeo.com/video/${m[1]}`;
};

const RenderVideo = (props) => {
    const { resource } = props;
    const link = resource?.link_video;

    const { vimeoVideoRef, loading, failed } = useVimeo(link);

    const embedSrc = vimeoPageToEmbed(link);

    return (
        <Root>
            {!failed ? (
                <VimeoPLayer ref={vimeoVideoRef} isLoading={loading} />
            ) : (
                <Iframe
                    src={embedSrc}
                    title={resource?.publication_name || 'Video'}
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                />
            )}
        </Root>
    );
};

export default RenderVideo;

const Root = styled.div`
    width: 100%;
    align-self: stretch;
    min-width: 0;
`;

const Iframe = styled.iframe`
    border: none;
    width: 100%;
    min-height: 400px;
    height: 100%;
`;

const VimeoPLayer = styled.div`
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    height: 0;
    overflow: hidden;
    max-width: 100%;
    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }
`;
